import type { IBreadcrumbBuild, IBreadcrumbConfig } from './types';

import { merge } from '../../helper';
import isEmptyArray from '../../general/isEmpty/isEmptyArray';

import * as exElement from '../../utils/element';
import { data } from './utils';

// ----------------------------------------------------------------------------

function create(config: IBreadcrumbConfig = {}): IBreadcrumbBuild {
    // Default Config
    const defConfig: IBreadcrumbConfig = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const builds: IBreadcrumbBuild = {
        element: {},
    } as IBreadcrumbBuild;

    // ------------------------------------------------------------------------

    // Create element (breadcrumb)
    const elBreadcrumb = exElement.create({
        merge: defConfig,
    });
    builds.element = elBreadcrumb;

    // ------------------------------------------------------------------------

    // Settings
    settings(builds, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return builds;
}

function settings(builds: IBreadcrumbBuild, config: IBreadcrumbConfig = {}): void {
    //
    if (!isEmptyArray(config.data)) {
        data(builds.element);
    }
}

// ----------------------------------------------------------------------------

export { create };
